export function parseBotInvite(text:string):{id:string;permissions:string[]}|null{
 try{
  const url=new URL(text);
  if(url.protocol!=='https:'||!['malvo.eu','www.malvo.eu'].includes(url.hostname)||url.pathname.replace(/\/$/,'')!=='/developer/authorize'||url.username||url.password)return null;
  const id=url.searchParams.get('app')||'';
  if(!/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(id))return null;
  return {id,permissions:[...new Set((url.searchParams.get('permissions')||'').split(',').filter(p=>/^[a-z_]{1,40}$/.test(p)))]};
 }catch{return null;}
}

export const inDesktopApp=()=>navigator.userAgent.includes('MalvoDesktop');
export function botInviteAppLink(invite:{id:string;permissions:string[]}){
 const params=new URLSearchParams({app:invite.id});
 if(invite.permissions.length)params.set('permissions',invite.permissions.join(','));
 return 'malvo://authorize?'+params;
}
// Hands a bot invite to the desktop app. Without the app nothing happens, and the dialog stays usable in the browser. Firefox would show an error page, so it only gets the button.
export function offerDesktopApp(invite:{id:string;permissions:string[]}){
 const ua=navigator.userAgent;
 if(!inDesktopApp()&&/Windows NT|Macintosh/.test(ua)&&!/Firefox/.test(ua))location.href=botInviteAppLink(invite);
}
